import {
	completeStage,
	fetchStage,
	fetchStages,
	missing,
	selectStage,
} from '../redux/slices/stageSlice';
import {
	display,
	fetchCountries,
	fetchFields,
	fetchPropertyInfo,
	fetchReservation,
	fetchReservationProfiles,
	fetchSettingLists,
	fetchTexts,
	fetchToken,
	resetPostComplete,
	selectSession,
	callAdyenWebhook,
} from '../redux/slices/sessionSlice';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hook';

import { DocumentLivenessVerification } from './parent/page';
import { fetchSupportedDocs } from '../redux/slices/documentSlice';
import IolPaymentForm from './payment/IolPaymentForm';
import StripePaymentForm from './StripePayment/StripepaymentForm';
import Loading from '../components/loading';
import { PaymentContainer } from './payment/page';
import ReservationProfileFormHome from './reservation-profile-form/page';
import Thanks from '../components/thanks';
import TNCDeclarationHome from './tnc-declaration/page';
import { useSearchParams } from 'react-router-dom';

export default function DisplayPage() {
	const [searchParams] = useSearchParams();
	const dispatch = useAppDispatch();

	useEffect(() => {
		console.log('searchParams', searchParams.get('confirmationNumber'));
		console.log('searchParams', searchParams.get('hotel'));
		console.log('searchParams', searchParams.get('propertyCode'));
		console.log('searchParams', searchParams.get('propertycode'));
		console.log('searchParams', searchParams.get('reservation'));
		console.log('searchParams', searchParams.toString());

		const propertyCode =
			searchParams.get('PropertyCode') ||
			searchParams.get('propertyCode') ||
			searchParams.get('propertycode') ||
			searchParams.get('hotel');
		if (!token && propertyCode) dispatch(fetchToken(propertyCode));
	}, [searchParams]);

	const { stages, stage } = useAppSelector(selectStage);
	const {
		token,
		propertyInfo,
		countries,
		fields,
		settings,
		reservation,
		profiles,
		isPostComplete: isSessionPostComplete,
		multiTexts,
		loading,
	} = useAppSelector(selectSession);

	useEffect(() => {
		if (
			isSessionPostComplete === false ||
			([true, null].includes(isSessionPostComplete) &&
				[
					stages,
					stage,
					token,
					countries,
					fields,
					reservation,
					profiles,
					propertyInfo,
				].every((element) => {
					return element;
				}))
		) {
			dispatch(display(false));
			dispatch(resetPostComplete());
		}
	}, [
		stages,
		stage,
		token,
		countries,
		reservation,
		profiles,
		isSessionPostComplete,
		propertyInfo,
		fields,
	]);

	useEffect(() => {
		if (token && !propertyInfo) dispatch(fetchPropertyInfo(token));
	}, [token, JSON.stringify(propertyInfo)]);

	useEffect(() => {
		if (token && !stages)
			dispatch(
				fetchStages({ token: token, type: process.env.REACT_APP_TYPE! })
			);
	}, [token, JSON.stringify(stages)]);

	useEffect(() => {
		if (token && stages && !stage && reservation?.PmsConfirmationNo)
			dispatch(
				fetchStage({
					token: token,
					type: process.env.REACT_APP_TYPE!,
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
				})
			);
	}, [
		token,
		JSON.stringify(stage),
		JSON.stringify(stages),
		reservation?.PmsConfirmationNo,
	]);

	useEffect(() => {
		if (token && !countries) dispatch(fetchCountries(token));
	}, [token, JSON.stringify(countries)]);

	useEffect(() => {
		if (token) dispatch(fetchSupportedDocs(token));
	}, [token]);

	useEffect(() => {
		const orderRef = searchParams.get('orderRef') ?? '';
		//const redirectResult = (searchParams.get('redirectResult') ?? '').replace('%', '%26');
		const redirectResult = searchParams.get('redirectResult') ?? '';
		if (orderRef && redirectResult) {
			dispatch(
				callAdyenWebhook({
					token: token,
					orderRef: orderRef,
					redirectResult: redirectResult,
				})
			).then(() => {
				const newSearchParams = orderRef.split('@');

				setTimeout(() => {
					window.location.href =
						window.location.origin +
						window.location.pathname +
						'?confirmationNumber=' +
						newSearchParams[0] +
						'&propertyCode=' +
						newSearchParams[1];
				}, 3000);
			});
		}
	}, [searchParams]);

	useEffect(() => {
		const confirmationNumber =
			(searchParams.get('confirmationNumber') ||
				searchParams.get('reservation')) ??
			'';

		if (
			propertyInfo !== null &&
			propertyInfo !== undefined &&
			propertyInfo?.propertyCode !== null &&
			propertyInfo?.propertyCode !== undefined &&
			propertyInfo?.propertyCode !== '' &&
			token &&
			!reservation &&
			//searchParams.get('confirmationNumber')
			confirmationNumber
		) {
			dispatch(
				fetchReservation({
					token: token,
					confirmationNo: confirmationNumber,
					propertyCode: propertyInfo?.propertyCode ?? '',
				})
			);
		}
	}, [
		token,
		JSON.stringify(reservation),
		JSON.stringify(propertyInfo),
		searchParams,
	]);

	useEffect(() => {
		if (token && reservation && profiles && countries && stage)
			dispatch(display(false));
	}, [
		token,
		JSON.stringify(reservation),
		JSON.stringify(profiles),
		JSON.stringify(countries),
		JSON.stringify(stage),
	]);

	useEffect(() => {
		if (token && !profiles && reservation?.PmsConfirmationNo)
			dispatch(
				fetchReservationProfiles({
					token,
					confirmationNo: reservation?.PmsConfirmationNo,
				})
			);
	}, [token, JSON.stringify(profiles), reservation?.PmsConfirmationNo]);

	useEffect(() => {
		if (
			reservation &&
			stage &&
			stages &&
			missing.includes(stage.stepID) &&
			reservation?.PmsConfirmationNo
		)
			dispatch(
				completeStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
				})
			);
	}, [
		token,
		JSON.stringify(stage),
		JSON.stringify(stages),
		JSON.stringify(reservation),
	]);

	/*
	 * To handle completeStage universal across all components
	 * completeStage is executed every time a page's POST request is fulfilled.
	 * This state of fulfillment is captured in every slice, with slice.isPostComplete.
	 * Note that: profile, document, signature are tightly coupled in the "parent component".
	 * The following useEffect is designed to work only on pages, and not parts of flows.
	 * Hence, the 3 components above are handled separately in the parent component.
	 */
	useEffect(() => {
		if (isSessionPostComplete && reservation?.PmsConfirmationNo) {
			dispatch(display(true));
			dispatch(
				completeStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
				})
			);
			dispatch(resetPostComplete());
		}
	}, [isSessionPostComplete, reservation?.PmsConfirmationNo]);

	useEffect(() => {
		if (token && !fields) dispatch(fetchFields(token));
	}, [token, JSON.stringify(fields)]);

	useEffect(() => {
		if (token && !settings) dispatch(fetchSettingLists(token));
	}, [token, JSON.stringify(settings)]);

	useEffect(() => {
		if (token && !multiTexts)
			dispatch(fetchTexts({ token: token, language: 'en' }));
	}, [token, JSON.stringify(multiTexts)]);

	return (
		<div className="theme-background">
			{!loading && stage && propertyInfo ? (
				stage.stepID === 1 ||
				stage.stepCode === 'SEI01' ||
				stage.stageCode === 'SEI01' ? (
					<ReservationProfileFormHome />
				) : stage.stepID === 2 ||
				  stage.stepCode === 'SEI02' ||
				  stage.stageCode === 'SEI02' ? (
					<DocumentLivenessVerification />
				) : stage.stepID === 3 ||
				  stage.stepCode === 'SEI03' ||
				  stage.stageCode === 'SEI03' ? (
					<Loading />
				) : stage.stepID === 4 ||
				  stage.stepCode === 'SEI04' ||
				  stage.stageCode === 'SEI04' ? (
					<TNCDeclarationHome />
				) : stage.stepID === 5 ||
				  stage.stepCode === 'SEI05' ||
				  stage.stageCode === 'SEI05' ? (
					propertyInfo?.embeddedPayVendor === 'IOL_PAY' ? (
						<IolPaymentForm />
					) : propertyInfo?.embeddedPayVendor === 'STRIPE_PAY' ? (
						<StripePaymentForm />
					) : (
						<PaymentContainer />
					)
				) : (
					<Thanks />
				)
			) : (
				<></>
			)}
		</div>
	);
}
